import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router';
import LocalIcon from '../Icon';
import {Pill} from './../../../ui/src/component/pill';
import {CsmSectionLink} from './../../../ui/src/component/csmSectionLink';
import './header.css';
// import logo from '../../../assets/kosice-online.png';
import logo2x from '../../../assets/kosice-online@2x-sk.png';
import logoVianoce from '../../../assets/KE_ONLINE_CIAPKA.png';
import radiokeLogo from '../../../assets/radio-ke.png';
import radiokeLogo2x from '../../../assets/radio-ke@2x.png';
import cx from 'classnames';
import {Popup} from './../popup';
import {LiveStreamWidget} from './../liveStreamWidget';
import {getProp} from '../../../ui/src/utilities';
import {SectionName} from '../../../ui/src/component/csmSectionLink/csmSectionLink';

class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            popupOpened: false,
            searchIsOpen: false,
        };
        this.handleClickSearch = this.handleClickSearch.bind(this);
    }

    onClickPopupItem(item) {
        this.setState({popupOpened: false});
    }

    handleClickSearch() {
        this.setState({searchIsOpen: !this.state.searchIsOpen});
    }

    switchChristmasLogo() {
        const now = new Date();
        if (now.getMonth() === 11 || (now.getMonth() === 0 && now.getDate() < 7)) {
            return logoVianoce;
        } else
            return logo2x
    }


    render() {
        let loggedUser = null;
        if (this.props.loggedUser) {
            loggedUser = getProp(this.props.loggedUser, 'display_name', '');
            if (!loggedUser) {
                loggedUser = getProp(this.props.loggedUser, 'email', '');
                if (!loggedUser) {
                    loggedUser = 'Moje konto';
                }
            }
        }

        return (
            <header className="header" id="header">
                <div className="container">
                    <div className="row">
                        <div
                            className="col-xs-12 col-header-left"
                            style={{paddingLeft: '30px'}}
                        >
                            <div className="row">
                                <div
                                    className="col-xs-12 col-logo"
                                    style={{paddingLeft: '0'}}
                                >
                                    <a href="/">
                                        <img
                                            src={this.switchChristmasLogo()}
                                            alt="Košice online"
                                            className="img-responsive"
                                        />
                                    </a>
                                </div>
                                <div
                                    className="col-xs-12 col-search hidden-xs hidden-sm"
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'flex-end',
                                    }}
                                >
                                    {this.state.searchIsOpen ? (
                                        <form
                                            className="input-group search-form"
                                            style={{
                                                display: 'flex',
                                                width: '100%',
                                                marginLeft: '20px',
                                            }}
                                            onSubmit={ev => {
                                                ev.preventDefault();
                                                this.setState({searchIsOpen: false});
                                                this.props.onSubmitSearch();
                                            }}
                                        >
                                            <div style={{width: '100%'}}>
                                                <input
                                                    type="search"
                                                    name=""
                                                    id=""
                                                    className="form-control"
                                                    placeholder="Hľadaný výraz"
                                                    value={this.props.searchQuery}
                                                    onChange={ev => {
                                                        // this.setState({ searchIsOpen: false });
                                                        this.props.onChangeSearchQuery(ev.target.value);
                                                    }}
                                                />
                                            </div>
                                            <div className>
                                                <button
                                                    type="submit"
                                                    className="btn btn-default"
                                                    style={{
                                                        border: 'none',
                                                        backgroundColor: '#F7F7F7',
                                                        outline: 'none',
                                                        marginRight: '1px',
                                                        marginTop: '1px',
                                                    }}
                                                >
                                                    <LocalIcon name="magnifier" height={23} width={23}/>
                                                </button>
                                            </div>
                                        </form>
                                    ) : (
                                        <div
                                            style={{
                                                marginTop: '11px',
                                                marginRight: '21px',
                                                cursor: 'pointer',
                                            }}
                                            onClick={this.handleClickSearch}
                                        >
                                            <LocalIcon name="magnifier" height={23} width={23}/>
                                        </div>
                                    )}
                                    <div
                                        style={{
                                            marginTop: '10px',
                                            marginLeft: '10px',
                                            marginRight: '23px',
                                        }}
                                    >
                                        {/* <LocalIcon name="user" height={23} width={23} /> */}
                                        <Link to="/moje-clanky">
                                            <LocalIcon name="user" height={23} width={23}/>
                                        </Link>
                                    </div>
                                </div>
                                <nav className="col-xs-12 col-navigation menuTop">
                                    <ul>
                                        {// hlavne menu lokalit
                                            (this.props.smarttags || []).map(item => {
                                                return (
                                                    <li key={item.id}>
                                                        <Link to={`/lokalita/${item.id}`}>{item.title}</Link>
                                                    </li>
                                                );
                                            })}
                                        {// sezonne menu
                                            this.props.seasonnav.map(item => {
                                                return (
                                                    <li key={item._id.toString()}>
                                                        <CsmSectionLink section={item}/>
                                                    </li>
                                                );
                                            })}
                                        <li>
                                            <Link to="/najcitanejsie">Najčítanejšie</Link>
                                        </li>
                                        <li className="my-profile">
                                            <Link to="/moje-clanky">
                                                {loggedUser ? (
                                                    <span>
                            <LocalIcon name="user" height={23} width={23}/>
                            <strong>{loggedUser}</strong>
                                                        {this.props.unreadArticles !== null &&
                                                        this.props.unreadArticles > 0 ? (
                                                            <span className="badge badge-primary badge-sup">
                                {this.props.unreadArticles}
                              </span>
                                                        ) : null}
                          </span>
                                                ) : (
                                                    'Moje konto'
                                                )}
                                            </Link>
                                        </li>
                                        <li style={{position: 'relative'}}>
                                            <div style={{display: 'inline-block'}}>
                                                <a
                                                    className="popup-trigger"
                                                    style={{position: 'relative'}}
                                                    href=""
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        this.setState({
                                                            popupOpened: !this.state.popupOpened,
                                                        })
                                                    }
                                                    }
                                                >
                                                    Viac&nbsp;<span
                                                    className={cx('chevron', {
                                                        inverted: this.state.popupOpened,
                                                    })}
                                                />
                                                </a>
                                                <div className="popup-container">
                                                    <Popup
                                                        eventTypes="click"
                                                        opened={this.state.popupOpened}
                                                        onClickItem={this.onClickPopupItem.bind(this)}
                                                        items={getProp(this.props, 'nav', []).map(item => (
                                                            <CsmSectionLink key={item._id} section={item}>
                                                                <SectionName height="20">{item.name}</SectionName>
                                                            </CsmSectionLink>
                                                        ))}
                                                        handleClickOutside={() =>
                                                            this.setState({popupOpened: false})
                                                        }
                                                        outsideClickIgnoreClass={'popup-trigger'}
                                                    />
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </nav>
                                <div className="col-xs-12 col-search hidden-md hidden-lg">
                                    <form
                                        className="input-group search-form"
                                        onSubmit={ev => {
                                            ev.preventDefault();
                                            this.props.onSubmitSearch();
                                        }}
                                    >
                                        <input
                                            type="search"
                                            name=""
                                            id=""
                                            className="form-control"
                                            placeholder="Hľadaný výraz"
                                            value={this.props.searchQuery}
                                            onChange={ev =>
                                                this.props.onChangeSearchQuery(ev.target.value)
                                            }
                                        />
                                        <span className="input-group-btn">
                      <button type="submit" className="btn btn-default">
                        <LocalIcon name="magnifier" height={23} width={23}/>
                      </button>
                    </span>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-header-right">
                            <a
                                href="http://www.radiokosice.sk/playlist"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="live-stream-widget-link"
                            >
                                <LiveStreamWidget
                                    logo={
                                        <img
                                            src={radiokeLogo}
                                            alt="Rádio Košice"
                                            srcSet={`${radiokeLogo2x} 2x`}
                                            className="img-responsive"
                                        />
                                    }
                                    currentSong={this.props.currentSong}
                                />
                            </a>
                            <div className="header-buttons">
                                <a
                                    href="https://www.tvkosice.sk/doprava"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Pill content={'Doprava naživo'}/>
                                </a>
                                <a
                                    href="https://www.tvkosice.sk/live"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <Pill content={'Live TV Košice'}/>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        );
    }
}

Header.propTypes = {
    smarttags: PropTypes.array.isRequired,
    nav: PropTypes.array.isRequired,
    searchQuery: PropTypes.string.isRequired,
    onChangeSearchQuery: PropTypes.func.isRequired,
    onSubmitSearch: PropTypes.func.isRequired,
    namedays: PropTypes.object,
    currentSong: PropTypes.string,
    loggedUser: PropTypes.object,
    seasonnav: PropTypes.array,
    unreadArticles: PropTypes.number,
};

export default Header;



// WEBPACK FOOTER //
// ./src/app/component/header/header.js